export const delay = (ms: number) => new Promise((resolve) => {
  setTimeout(() => {
    resolve(undefined);
  }, ms);
});

export const jsonParseSafe = <T = any>(json?: string | number | null): T | null => {
  if (!json || typeof json !== 'string') {
    return null;
  }
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
};
